/*
 * @Author: your name
 * @Date: 2022-02-07 15:23:26
 * @LastEditTime: 2025-03-05 16:45:49
 * @LastEditors: kevinqq 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsySelectCheckBox\index.jsx
 */
import React, { Component } from "react";
import { BsyConfig } from "../../global/BsyConfig";

import { BsyUtils } from "../../utils/Utils";
import BsyMsgBubble from "../BsyMsgBubble";
import BsySelect, { TriggerComboPane } from "../BsySelect";
import "./index.css";

export default class BsyDeptCheckBox extends BsySelect {
  constructor(props) {
    super({
      // baseCls: "fx_dept_check",
      waterMark: null,
      hasSelectAll: !0,
      hasSelectCurrent: !0,
      hasSelectEmpty: !0,
      textField: "name",
      valueField: "_id",
      searchable: !0,
      onStopEdit: null,
      height: 30,
      // width: 350,
      edge: {
        width: 240,
        height: 330,
      },
      value: {
        items: [],
      },
      dynamicType: "select",
      limit: {},
      searchKey: "keyword",
      hasScrollLoad: !1,
      multiSelect: !0,
      allowBlank: !1,
      parentDepts: [],
      async: true,
      ...props,
    });
    this.state = {
      ...this.state,
      rsync: true,
      value: this.value2statevalue(this.options.value),
    };
    this.page = 0;
    this.isAllSelect = false;
  }

  autoSelectList = (event) => {
    const { async } = this.options;

    let that = this;
    // return (event) => {
    // event.stopPropagation()
    const { showList, items } = this.state;

    if (showList) {
      if (that.showLoadingHandle) {
        that.showLoadingHandle.closeAlter();
        that.showLoadingHandle = null;
      }
      that.setState(
        {
          showList: false,
        },
        () => {
          if (that.props.onStopEdit) {
            that.props.onStopEdit(that.getValue(), null, that);
          }
        }
      );
      return;
    }

    let currentTarget = event.currentTarget;
    let dd = items ? [...items] : [];
    if (async && BsyUtils.isObjectEmpty(dd)) {
      if (
        BsyUtils.isObjectEmpty(
          window.FX.STATIC[
            window.FX.STATIC.APPID + window.FX.STATIC.ENTRYID + "G_Departments"
          ]
        )
      ) {
        this.showLoading(currentTarget);
        this.loadData(0, () => {
          const { showList } = this.state;

          if (showList) {
            return;
          }
          this.setState(
            {
              showList: !showList,
            },
            () => {
              that.showCombo(currentTarget);
            }
          );
          return;
        });
        return;
      }
      dd = [
        ...window.FX.STATIC[
          window.FX.STATIC.APPID + window.FX.STATIC.ENTRYID + "G_Departments"
        ],
      ];
    }

    if (showList) {
      return;
    }
    this.setState(
      {
        items: dd,
        showList: !showList,
      },
      () => {
        that.showCombo(currentTarget);
      }
    );
    // }
  };

  showCombo = (currentTarget) => {
    const {
      searchable,
      textField,
      valueField,
      allowBlank,
      hasSelectAll,
      multiSelect,
      hasCurrentDept,
      hasCurrentSubDept,
      hasParentsDept,
      hasCurrentParDept,
      dynamicType,
    } = this.options;
    const { items, value } = this.state;
    let width = this.element.current.offsetWidth;
    let that = this;
    this.isEditd = false;
    let height = this.element.current.offsetHeight < 32 ? 32 : this.element.current.offsetHeight;
    BsyMsgBubble({
      anchor: currentTarget,
      contentHTML: (ref) => {
        if (that.showLoadingHandle) {
          that.showLoadingHandle.closeAlter();
          that.showLoadingHandle = null;
        }
        let ddc = [...items];
        if (!window.FX.STATIC.QTOKEN) {
          if (
            hasCurrentDept ||
            hasCurrentSubDept ||
            hasParentsDept ||
            hasCurrentParDept
          ) {
            if ("set" === dynamicType) {
              if (!window.FX.STATIC.QTOKEN) {
                ddc.push({
                  _id: "dynamic",
                  name:
                    React.language("dynamic") + React.language("department"),
                  // icon: 'icon-bsy-dynamic',
                  fixed: true,
                });
              }
              ddc = ddc.concat([
                {
                  _id: BsyConfig().CONST.DEPT_ID.CURRENT,
                  name: React.language("dept.current"),
                },
                {
                  _id: BsyConfig().CONST.DEPT_ID.CURRENT2,
                  name: React.language("top.department"),
                },
                {
                  _id: BsyConfig().CONST.DEPT_ID.CURRENT3,
                  name: React.language("tertiary.department"),
                },
                {
                  _id: BsyConfig().CONST.DEPT_ID.CURRENT4,
                  name: React.language("fourth.department"),
                },
                {
                  _id: BsyConfig().CONST.DEPT_ID.CURRENT5,
                  name: React.language("fifth.department"),
                },
                {
                  _id: BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT,
                  name: React.language("department.sub.department"),
                },
                {
                  _id: BsyConfig().CONST.DEPT_ID.CURRENT_PARDEPT,
                  name: React.language("department.hasCurrentParDept"),
                },
              ]);
            }
          }
        }

        return (
          <TriggerDeptCheckPane
            multiSelect={multiSelect}
            items={ddc}
            itemHeight={height}
            textField={textField}
            valueField={valueField}
            searchable={searchable}
            allowBlank={allowBlank}
            searchValue={that.searchValue}
            hasSelectAll={hasSelectAll}
            value={value}
            onSelect={(val) => {
              that.selectItem(val, ref);
            }}
            onSeach={this.onSeach}
          />
        );
      },
      text4Cancel: null,
      text4Ok: null,
      theme: this.props.theme,
      minWidth: "auto",
      width: width < 150 ? 150 : width,
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "left",
      onClose: function () {
        if (multiSelect) {
          if (that.isEditd) {
            if (that.props.onStopEdit) {
              that.props.onStopEdit(that.state.value);
            }
          }
        }
        // that.setState({
        //     showList: !1,
        // }, () => {
        //     if (multiSelect) {
        //         if (that.isEditd) {
        //             if (that.props.onStopEdit) {
        //                 that.props.onStopEdit(that.state.value)
        //             }
        //         }
        //     }
        // })
        return !1;
      },
    });
  };

  selectItem = (val, ref) => {
    const { multiSelect } = this.options;
    this.isEditd = true;
    if (multiSelect) {
      this.setState({
        value: [...val],
      });
    } else {
      this.setState(
        {
          value: val,
        },
        () => {
          if (this.props.onStopEdit) {
            this.props.onStopEdit(this.state.value, null, this);
          }
          ref.closeAlter();
        }
      );
    }
  };

  componentDidMount() {
    super.componentDidMount();
    const { value } = this.state;
    if (
      BsyUtils.isObjectEmpty(
        window.FX.STATIC[
          window.FX.STATIC.APPID + window.FX.STATIC.ENTRYID + "G_Departments"
        ]
      )
    ) {
      if (!BsyUtils.isObjectEmpty(value)) {
        this.loadData(0, () => {
          this.setState({}, () => {
            // if (this.props.onStopEdit) {
            //     this.props.onStopEdit(this.state.value)
            // }
          });
        });
      }
    } else {
      this.setState(
        {
          items: [
            ...window.FX.STATIC[
              window.FX.STATIC.APPID +
                window.FX.STATIC.ENTRYID +
                "G_Departments"
            ],
          ],
        },
        () => {
          // if (this.props.onStopEdit) {
          //     this.props.onStopEdit(this.state.value)
          // }
        }
      );
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const { items } = this.state;
    const { multiSelect } = this.options;
    let pvalue = this.value2statevalue(nextProps.value);
    if (multiSelect) {
      if (!BsyUtils.compare(this.state.value, pvalue)) {
        if (!BsyUtils.isObjectEmpty(pvalue) && BsyUtils.isObjectEmpty(items)) {
          this.loadData(0, () => {
            this.setState({
              value: [...pvalue],
            });
          });
        } else {
          this.setState({
            value: [...pvalue],
          });
        }
      }
    } else {
      if (this.state.value !== pvalue) {
        if (!BsyUtils.isObjectEmpty(pvalue) && BsyUtils.isObjectEmpty(items)) {
          this.loadData(0, () => {
            this.setState({
              value: pvalue,
            });
          });
        } else {
          this.setState({
            value: pvalue,
          });
        }
      }
    }
  }

  transformToTreeFormat = (b) => {
    let simpleData = {
      enable: true,
      idKey: "departmentId",
      pIdKey: "parentId",
    };
    var c,
      d,
      e = simpleData.idKey,
      f = simpleData.pIdKey,
      g = "children";
    if (!e || "" == e || !b) return [];
    if (Array.isArray(b)) {
      var h = [],
        i = [];
      for (c = 0, d = b.length; c < d; c++) {
        i[b[c][e]] = b[c];
      }

      for (c = 0, d = b.length; c < d; c++) {
        if (i[b[c][f]] && b[c][e] != b[c][f]) {
          i[b[c][f]][g] || (i[b[c][f]][g] = []);

          b[c].title = b[c].name;
          b[c].key = b[c].departmentId;
          i[b[c][f]][g].push(b[c]);
        } else {
          b[c].title = b[c].name;
          b[c].key = b[c].departmentId;
          h.push(b[c]);
        }
      }
      return h;
    }
    b.title = b.name;
    b.key = b.departmentId;
    return [b];
  };

  transformToTreeFormat = (b) => {
    let c,
      d,
      e = "departmentId",
      f = "parentId",
      g = "children",
      l = "level";
    if (!e || "" == e || !b) return [];
    if (BsyUtils.isArray(b)) {
      let h = [],
        i = [];
      for (c = 0, d = b.length; c < d; c++) i[b[c][e]] = b[c];
      for (c = 0, d = b.length; c < d; c++) {
        if (i[b[c][f]] && b[c][e] != b[c][f]) {
          i[b[c][f]][g] || (i[b[c][f]][g] = []);
          // 修正level属性
          b[c][l] = (i[b[c][f]][l] || 0) + 1;
          i[b[c][f]][g].push(b[c]);
        } else {
          // 修正level属性
          b[c][l] = 0;
          h.push(b[c]);
        }
      }
      return h;
    }
    // 修正level属性
    b[l] = 0;
    return [b];
  };

  loadData = (skip, cb) => {
    const {
      hasSelectEmpty,
      emptyId,
      hasCurrentDept,
      hasCurrentSubDept,
      hasParentsDept,
      hasCurrentParDept,
      dynamicType,
    } = this.options;

    let items = [];

    if (hasSelectEmpty) {
      items.push({
        _id: BsyConfig().CONST.PARAMETER.EMPTY,
        name: React.language("unfilled"),
      });
    }
    if (!window.FX.STATIC.QTOKEN) {
    } else {
      this.setState(
        {
          items: items,
        },
        () => {
          cb && cb();
        }
      );
      return;
    }

    React.axios("/data/member/departments", {
      appId: window.FX.STATIC.APPID,
    })
      .then((res) => {
        BsyUtils.showAjaxTip(res.data, () => {
          let dd = this.transformToTreeFormat(res.data["departments"]);
          let dd1 = this.transformToTreeFormat(res.data["label_corp_list"]);
          dd1 = dd1[0] ? dd1[0].children : [];
          console.log(dd1);
          // console.log(dd)
          if (!window.FX.STATIC.QTOKEN) {
            items.push({
              _id: "organization",
              name: React.language("organization"),
              // icon: 'icon-bsy-organization',
              fixed: true,
            });
            dd[0].open = true;
          }

          items = [...items, ...dd];

          if (dd1.length > 0) {
            items.push({
              _id: "dockcorp",
              name: React.language("organization.external"),
              // icon: 'icon-bsy-organization',
              fixed: true,
            });
            dd1[0].open = true;
            items = [...items, ...dd1];
          }

          React.axios("/data/outsider/list", {
            appId: window.FX.STATIC.APPID,
          })
            .then((res) => {
              BsyUtils.showAjaxTip(res.data, () => {
                if (!window.FX.STATIC.QTOKEN) {
                  items.push({
                    _id: "outsiderGroup",
                    name: React.language("outsiderGroup"),
                    // icon: 'icon-bsy-outsiderGroup',
                    fixed: true,
                  });
                }

                items = [...items, ...res.data["list"]];

                //当前页面有多个部门筛选条件请求的时候，临时缓存，减少不必要的请求
                var d = [];
                items.map((res, key) => {
                  if (res.status !== -99) {
                    d.push(res);
                  }
                });
                window.FX.STATIC[
                  window.FX.STATIC.APPID +
                    window.FX.STATIC.ENTRYID +
                    "G_Departments"
                ] = [...d];
                this.setState(
                  {
                    items: items,
                  },
                  () => {
                    cb && cb();
                  }
                );
              });
            })
            .catch((res) => {
              console.error(res);
              this.setState(
                {
                  items: items,
                },
                () => {
                  cb && cb();
                }
              );
            });
        });
      })
      .catch((res) => {
        console.error(res);
        this.setState(
          {
            items: items,
          },
          () => {
            cb && cb();
          }
        );
      });
  };

  onSeach = (val, cb) => {
    const { items } = this.state;
    const { valueField, textField } = this.options;
    this.searchValue = val;
    if (!this.searchValue) {
      this.setState(
        {
          items: this.bakAllitems,
          seaching: false,
        },
        () => {
          cb && cb([...this.state.items]);
          this.bakAllitems = null;
        }
      );
    } else {
      if (BsyUtils.isObjectEmpty(this.bakAllitems)) {
        this.bakAllitems = [...items];
      }

      let searchValue = [];

      let foreachChild = (data) => {
        data &&
          data.map((val) => {
            if (!val.fixed && val[textField].indexOf(this.searchValue) > -1) {
              searchValue.push({
                [textField]:
                  val[textField] +
                  (val.mode === "outsider"
                    ? "(" +
                      React.language("outside") +
                      React.language("group") +
                      ")"
                    : "") +
                  (val.status === -99 ? React.language("deling") : ""),
                [valueField]: val[valueField],
              });
            }

            if (val.children) {
              foreachChild(val.children);
            }
          });
      };
      foreachChild(this.bakAllitems);

      this.setState(
        {
          items: searchValue,
        },
        () => {
          cb && cb([...this.state.items]);
        }
      );
    }
  };

  value2statevalue = (t) => {
    let val = [];
    if (BsyUtils.isObjectEmpty(t)) return val;
    if (Array.isArray(t)) {
      val = t;
    } else {
      if (t) {
        if (!t.parentDepts) {
          t.parentDepts = [];
        }

        if (!t.items) {
          t.items = [];
        }

        if (!t.value) {
          t.value = [];
        }

        if (BsyUtils.isString(t.value)) {
          val = [...val, ...[t.value]];
        } else {
          val = [...val, ...t.value];
        }
        val = [...val, ...t.items];
        val = [...val, ...t.parentDepts];
        if (t.hasEmpty) {
          val.push(BsyConfig().CONST.PARAMETER.EMPTY);
        }
        if (t.hasCurrentDept) {
          val.push(BsyConfig().CONST.DEPT_ID.CURRENT);
        }
        if (t.hasCurrentSubDept) {
          val.push(BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT);
        }
        if (t.hasCurrentParDept) {
          val.push(BsyConfig().CONST.DEPT_ID.CURRENT_PARDEPT);
        }
      }
    }

    if (!this.options.multiSelect) {
      val = val.length > 0 ? val[0] : null;
    }
    return val;
  };

  getOrgValue = (a) => {
    const { items, value } = this.state;
    const { valueField, textField, multiSelect } = this.options;

    let newdd = [];
    let foreachChild = (data) => {
      data &&
        data.map((val) => {
          if (a.indexOf(val[valueField]) > -1) {
            newdd.push(val[valueField]);
          }
          if (val.children) {
            foreachChild(val.children);
          }
        });
    };
    foreachChild(items);

    return newdd;
  };

  getValue = () => {
    if (BsyUtils.isObjectEmpty(this.state.value)) return {};
    var t = [].concat(this.state.value),
      e = !1,
      i = !1,
      j = !1,
      a = [];
    var parents = [];
    var hasCurrentParDept = !1;
    BsyUtils.forEach(t, function (t, n) {
      switch (n) {
        case BsyConfig().CONST.PARAMETER.EMPTY:
          e = !0;
          break;
        case BsyConfig().CONST.DEPT_ID.CURRENT:
          i = !0;
          break;
        case BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT:
          j = !0;
          break;
        case BsyConfig().CONST.DEPT_ID.CURRENT_PARDEPT:
          hasCurrentParDept = !0;
          break;
        case BsyConfig().CONST.DEPT_ID.CURRENT2:
        case BsyConfig().CONST.DEPT_ID.CURRENT3:
        case BsyConfig().CONST.DEPT_ID.CURRENT4:
        case BsyConfig().CONST.DEPT_ID.CURRENT5:
          parents.push(n);
          break;
        default:
          a.push(n);
      }
    });

    let newdd = this.getOrgValue(a);

    return {
      hasCurrentDept: i,
      hasCurrentSubDept: j,
      hasCurrentParDept: hasCurrentParDept,
      hasEmpty: e,
      items: newdd,
      parentDepts: parents,
    };
  };

  renderSelectList = () => {
    const {
      searchable,
      seaching,
      hasSelectAll,
      textField,
      valueField,
      multiSelect,
      allowBlank,
    } = this.options;
    const { showList, css, items, value } = this.state;
    const { isAllSelect } = this;
    if (showList) {
      return (
        <div style={css} className="selectList">
          {searchable ? (
            <div className="bsy-combo-search">
              <input
                onChange={this.seachItems}
                value={this.searchValue}
                ref={this.seachRef}
              ></input>
              <i className="icon-bsy-reportmenu-0"></i>
            </div>
          ) : (
            <></>
          )}
          {seaching && (
            <div className="loading-text">
              <span>{React.language("searching")}</span>
            </div>
          )}
          {!multiSelect && !seaching && allowBlank ? (
            <div
              key={"empty"}
              onClick={this.selectItem("")}
              className={"item"}
              style={{
                fontSize: 14,
                fontWeight: "bold",
                height: this.options.itemHeight,
              }}
            >
              {React.language("select1")}
            </div>
          ) : (
            <></>
          )}
          {multiSelect && !seaching && hasSelectAll ? (
            <div
              key={"all"}
              onClick={this.onSelectAll}
              className={
                "item bsy-x-check select-all field-meta " +
                (isAllSelect ? "select" : "")
              }
            >
              <i className="icon-blank"></i>
              <span style={{ color: "#0265ff" }}>
                {React.language("selectAll")}
              </span>
            </div>
          ) : (
            <></>
          )}

          {!seaching && this.renderDD()}
        </div>
      );
    }

    return <></>;
  };

  showItem = () => {
    const { items, value } = this.state;
    const { valueField, textField, multiSelect } = this.options;
    let text = [];
    let valuess = [];
    if (BsyUtils.isObjectEmpty(value)) {
      return text;
    }
    let dd = items.concat([
      {
        _id: BsyConfig().CONST.DEPT_ID.CURRENT,
        name: React.language("dept.current"),
      },
      {
        _id: BsyConfig().CONST.DEPT_ID.CURRENT2,
        name: React.language("top.department"),
      },
      {
        _id: BsyConfig().CONST.DEPT_ID.CURRENT3,
        name: React.language("tertiary.department"),
      },
      {
        _id: BsyConfig().CONST.DEPT_ID.CURRENT4,
        name: React.language("fourth.department"),
      },
      {
        _id: BsyConfig().CONST.DEPT_ID.CURRENT5,
        name: React.language("fifth.department"),
      },
      {
        _id: BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT,
        name: React.language("department.sub.department"),
      },
      {
        _id: BsyConfig().CONST.DEPT_ID.CURRENT_PARDEPT,
        name: React.language("department.hasCurrentParDept"),
      },
    ]);

    if (multiSelect) {
      let foreachChild = (data) => {
        data &&
          data.map((val) => {
            if (val.type === "label" || val.type === "dockcorpdept") {
              if (val.children) {
                foreachChild(val.children);
              }
              return;
            }
            if (val.selected || value.indexOf(val[valueField]) > -1) {
              if (
                !BsyUtils.isObjectEmpty(val[valueField]) &&
                valuess.indexOf(val[valueField]) < 0
              ) {
                var t = val[textField];
                if (val.status === -99) {
                  t = val[textField] + React.language("deling");
                }
                text.push(t);
                valuess.push(val[valueField]);
              }
            }
            if (val.children) {
              foreachChild(val.children);
            }
          });
      };
      foreachChild(dd);
      value.map((data) => {
        if (data === BsyConfig().CONST.PARAMETER.EMPTY) {
          return null;
        }
        // if (valuess.indexOf(data) === -1) {
        //     text.push(data);
        // }
      });
    } else {
      let foreachChild = (data) => {
        data &&
          data.map((val) => {
            var t = val[textField];
            if (val.status === -99) {
              t = val[textField] + React.language("deling");
            }
            if (BsyUtils.isObjectEmpty(value)) {
              if (val.selected)
                !BsyUtils.isObjectEmpty(val[valueField]) && (text = t);
            } else {
              if (val[valueField] === value)
                !BsyUtils.isObjectEmpty(val[valueField]) && (text = t);
            }
            if (val.children) {
              foreachChild(val.children);
            }
          });
      };
      foreachChild(dd);

      if (BsyUtils.isObjectEmpty(text)) {
        if (value) {
          text = [value];
        }
      }
      if (BsyUtils.isString(text)) {
        text = [text];
      }
    }
    return text;
  };
}

export class TriggerDeptCheckPane extends TriggerComboPane {
  constructor(props) {
    super(props);
    this.state = {
      css: {},
      seaching: false,
      value: this.options.value,
      items: this.options.items,
    };
    this.searchValue = this.options.searchValue;
    this.elementRef = React.createRef();
    this.seachRef = React.createRef();

    this.isAllSelect = true;
    let foreachChild = (data) => {
      data &&
        data.map((dd) => {
          if (dd.fixed) {
            return dd;
          }
          if (
            this.state.value &&
            this.state.value.indexOf(dd[this.options.valueField]) === -1
          ) {
            this.isAllSelect = false;
            return false;
          }
          if (dd.children) {
            foreachChild(dd.children);
          }
        });
    };
    foreachChild(this.options.items);
  }

  renderList = () => {
    const { textField, valueField } = this.options;
    const { seaching, items, value } = this.state;
    return (
      <>
        {!seaching &&
          items &&
          items.map((val) => {
            if (value.indexOf(val[valueField]) > -1) {
              val.selected = true;
            } else {
              val.selected = false;
            }
            return (
              <div
                key={val[valueField]}
                title={
                  val[textField] +
                  (val.mode === "outsider"
                    ? "(" +
                      React.language("outside") +
                      React.language("group") +
                      ")"
                    : "")
                }
                onClick={this.selectItem(val[valueField])}
                style={{
                  height: this.options.itemHeight
                }}
                className={
                  val.selected
                    ? " item bsy-x-check select "
                    : "item bsy-x-check "
                }
              >
                <i className="icon-blank"></i>
                <span>
                  {val[textField] +
                    (val.mode === "outsider"
                      ? "(" +
                        React.language("outside") +
                        React.language("group") +
                        ")"
                      : "")}
                </span>
              </div>
            );
          })}
      </>
    );
  };

  onSelectAll = () => {
    const { isAllSelect } = this;
    const { items, value } = this.state;
    const { valueField } = this.options;
    let tmpvalue = value ? [...value] : [];

    let isallSelect = !isAllSelect;
    let values = [];

    let foreachChild = (data) => {
      data &&
        data.map((val) => {
          if (isallSelect) {
            if (!val.fixed) {
              let d = tmpvalue.indexOf(data[valueField]);
              if (d == -1) {
                values.push(val[valueField]);
              }
            }
          }
          if (val.children) {
            foreachChild(val.children);
          }
        });
    };
    foreachChild(items);

    this.isAllSelect = isallSelect;
    if (!this.isAllSelect) {
      values = [];
    }
    this.setState(
      {
        value: values,
      },
      () => {
        if (this.props.onSelect) {
          this.props.onSelect(this.state.value);
        }
      }
    );
  };

  renderChildNode = (data, index) => {
    const { multiSelect, textField, valueField } = this.options;
    const { value } = this.state;
    return (
      <>
        {data &&
          data.map((val) => {
            let selected = val.selected;
            let classNames = "";

            if (val.status === -99 && !val.hasOwnProperty("mode")) {
              return null;
            }
            if (val.fixed) {
              return (
                <div
                  key={val[valueField]}
                  style={{
                    height: this.options.itemHeight,
                  }}
                  className={" item bsy-x-check fixed"}
                >
                  <i className={val.icon}></i>
                  <span>
                    {val[textField] +
                      (val.mode === "outsider"
                        ? "(" +
                          React.language("outside") +
                          React.language("group") +
                          ")"
                        : "")}
                  </span>
                </div>
              );
            }

            if (multiSelect) {
              selected = value.indexOf(val[valueField]) > -1;
              classNames = selected
                ? " item bsy-x-check select "
                : "item bsy-x-check ";
            } else {
              selected = value === val[valueField];
              classNames = selected ? "item select " : "item ";
            }

            if (
              val.hasOwnProperty("corpId") ||
              val.type === "label" ||
              val.type === "dockcorp" ||
              val.type === "dockcorpdept" ||
              val.type === "dockdept"
            )
              classNames = classNames + " csp-" + index;

            if (
              val.hasOwnProperty("corpId") ||
              val.type === "label" ||
              val.type === "dockcorp" ||
              (val.type === "dockcorpdept" &&
                val.children &&
                val.children.length > 0) ||
              val.type === "dockdept"
            ) {
              return (
                <div
                  key={val[valueField]}
                  className={(val.open ? "expand" : "") + " pid-" + val._id}
                >
                  <div
                    title={
                      val[textField] +
                      (val.mode === "outsider"
                        ? "(" +
                          React.language("outside") +
                          React.language("group") +
                          ")"
                        : "")
                    }
                    onClick={
                      val.type !== "label" && val.type !== "dockcorpdept"
                        ? this.selectItem(val[valueField])
                        : ""
                    }
                    className={classNames}
                  >
                    {
                      //折叠
                      (val.hasOwnProperty("corpId") ||
                        val.type === "label" ||
                        val.type === "dockcorp" ||
                        val.type === "dockcorpdept" ||
                        val.type === "dockdept") &&
                      val.children &&
                      val.children.length > 0 ? (
                        <i
                          onClick={(e) => {
                            let tag = this.elementRef.current.querySelector(
                              ".pid-" + val._id
                            );
                            if (tag) {
                              if (tag.classList.contains("expand")) {
                                tag.classList.remove("expand");
                                if (tag.querySelector(".children"))
                                  tag.querySelector(".children").style.display =
                                    "none";
                                if (tag.querySelector(".open")) {
                                  tag
                                    .querySelector(".open")
                                    .classList.remove("icon-tree-collapse");
                                  tag
                                    .querySelector(".open")
                                    .classList.add("icon-tree-expand");
                                }
                              } else {
                                tag.classList.add("expand");
                                if (tag.querySelector(".children"))
                                  tag.querySelector(".children").style.display =
                                    "";
                                if (tag.querySelector(".open")) {
                                  tag
                                    .querySelector(".open")
                                    .classList.add("icon-tree-collapse");
                                  tag
                                    .querySelector(".open")
                                    .classList.remove("icon-tree-expand");
                                }
                              }
                            }
                            e.stopPropagation();
                          }}
                          className={
                            val.open
                              ? " open icon-tree-collapse"
                              : " open icon-tree-expand"
                          }
                        ></i>
                      ) : (
                        <i className="blank"></i>
                      )
                    }
                    {
                      //多选的效果
                      val.type !== "label" &&
                        val.type !== "dockcorpdept" &&
                        multiSelect && <i className="icon-blank"></i>
                    }
                    {
                      //部门标识
                      (val.hasOwnProperty("corpId") ||
                        val.type === "dockdept") && (
                        <i className="icon-dept-title"></i>
                      )
                    }
                    {val.type === "label" && (
                      <i className="icon-corp-label"></i>
                    )}
                    {(val.type === "dockcorpdept" ||
                      val.type === "dockcorp") && (
                      <i className="icon-bsy-iconqiyeshezhi"></i>
                    )}
                    <span>
                      {val[textField] +
                        (val.mode === "outsider"
                          ? "(" +
                            React.language("outside") +
                            React.language("group") +
                            ")"
                          : "")}
                    </span>
                    <i className="corpTip">
                      {val.type === "dockcorp"
                        ? "(" + React.language("contact.docking.people") + ")"
                        : val.type === "dockcorpdept"
                        ? "(" + React.language("contact.docking.dept") + ")"
                        : ""}
                    </i>
                  </div>
                  {val.children && (
                    <div
                      className={"children"}
                      style={{
                        display: val.open ? "" : "none",
                      }}
                    >
                      {this.renderChildNode(val.children, index + 1)}
                    </div>
                  )}
                </div>
              );
            }
            if (
              val.type === "dockcorpdept" &&
              val.children &&
              val.children.length <= 0
            ) {
              return "";
            }
            return (
              <div
                key={val[valueField]}
                onClick={this.selectItem(val[valueField])}
                className={classNames}
              >
                {
                  //多选的效果
                  multiSelect && <i className="icon-blank"></i>
                }
                <span>
                  {val[textField] +
                    (val.mode === "outsider"
                      ? "(" +
                        React.language("outside") +
                        React.language("group") +
                        ")"
                      : "")}
                </span>
              </div>
            );
          })}
      </>
    );
  };

  renderDD = () => {
    const { items } = this.state;

    if (items) {
      return this.renderChildNode(items, 0);
    }
    return <></>;
  };

  selectItem = (val) => {
    return () => {
      const { items, value } = this.state;
      const { textField, valueField, multiSelect } = this.options;

      let values = [];

      if (multiSelect) {
        let isallSelect = true;
        values = [...value];
        let d = values.indexOf(val);
        if (d === -1) {
          values.push(val);
        } else {
          values.splice(d, 1);
        }
        let foreachChild = (data) => {
          data &&
            data.map((dd) => {
              if (values.indexOf(dd[valueField]) === -1) {
                isallSelect = false;
              }
              dd.children && foreachChild(dd.children);
              // if(val === dd[valueField] && dd.type === "label"){
              //     let d = values.indexOf(val);
              //     values.splice(d, 1);
              // }
            });
        };
        foreachChild(items);
        this.isAllSelect = isallSelect;
      } else {
        values = val;
      }
      this.setState(
        {
          value: values,
        },
        () => {
          if (this.props.onSelect) {
            this.props.onSelect(this.state.value);
          }
        }
      );
    };
  };

  checkIsAllSelect = () => {
    const { items, value } = this.state;
    const { textField, valueField, multiSelect } = this.options;
    this.isAllSelect = true;
    if (!value) {
      let foreachChild = (data) => {
        data &&
          data.map((dd) => {
            if (dd.selected) {
              this.isAllSelect = false;
              return false;
            }
            if (dd.children) {
              foreachChild(dd.children);
            }
          });
      };
      foreachChild(items);
    } else {
      let foreachChild = (data) => {
        data &&
          data.map((dd) => {
            if (value.indexOf(data[valueField]) === -1) {
              this.isAllSelect = false;
              return false;
            }
            if (dd.children) {
              foreachChild(dd.children);
            }
          });
      };
      foreachChild(items);
    }
  };

  render() {
    const { cssName, searchable, hasSelectAll, multiSelect, allowBlank } =
      this.options;
    const { seaching, items } = this.state;

    return (
      <div className={cssName} ref={this.elementRef}>
        {searchable ? (
          <div className="bsy-combo-search">
            <input
              onChange={this.seachItems}
              value={this.searchValue}
              ref={this.seachRef}
            ></input>
            <i className="icon-bsy-reportmenu-0"></i>
          </div>
        ) : (
          <></>
        )}
        <div className="bsy-select-list">
          {seaching && (
            <div className="loading-text">
              <span>{React.language("searching")}</span>
            </div>
          )}
          {!multiSelect && !seaching && allowBlank ? (
            <div
              key={"empty"}
              onClick={this.selectItem("")}
              className={"item"}
              style={{
                fontSize: 14,
                fontWeight: "bold",
                height: this.options.itemHeight,
              }}
            >
              {React.language("select1")}
            </div>
          ) : (
            <></>
          )}
          {multiSelect && !seaching && hasSelectAll ? (
            <div
              key={"all"}
              onClick={this.onSelectAll}
              style={{
                height: this.options.itemHeight
              }}
              className={
                "item bsy-x-check select-all field-meta " +
                (this.isAllSelect ? "select" : "")
              }
            >
              <i className="icon-blank"></i>
              <span style={{ color: "#0265ff" }}>
                {this.searchValue
                  ? React.language("selectAllSearchResult")
                  : React.language("selectAll")}
              </span>
            </div>
          ) : (
            <></>
          )}

          {!seaching && this.renderDD()}
        </div>
      </div>
    );
  }
}
